/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Server_Errors_Nopermission1Inputs */

const he_server_errors_nopermission1 = /** @type {(inputs: Server_Errors_Nopermission1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אין לך הרשאה לבצע פעולה זו`)
};

const en_server_errors_nopermission1 = /** @type {(inputs: Server_Errors_Nopermission1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You do not have permission to perform this action`)
};

/**
* | output |
* | --- |
* | "You do not have permission to perform this action" |
*
* @param {Server_Errors_Nopermission1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const server_errors_nopermission1 = /** @type {((inputs?: Server_Errors_Nopermission1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Server_Errors_Nopermission1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_server_errors_nopermission1(inputs)
	return en_server_errors_nopermission1(inputs)
});
export { server_errors_nopermission1 as "server_errors_noPermission" }